const languageObj = {
  "Audio Compressor": "ضاغط صوتي",
  "HitPaw Online Audio Compressor": "ضاغط الصوت HitPaw Online",
  "Reduce audio file size online without quality loss.": "تقليل حجم ملف الصوت عبر الإنترنت دون فقدان الجودة.",
  "Compress": "ضغط",
  "Compressing": "ضغط",
  "Compressed Successfully": "تم ضغطه بنجاح",
  "Compress New": "ضغط جديد",
  "Compression is complete": "اكتمل الضغط",
  "Compression failed": "فشل الضغط",
  "Quality": "جودة",
  "Format": "صيغة",
  "Add file": "اضف ملف",
  "Output Settings": "ضبط الانتاج",

};

export default languageObj

